
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Setting',
    props: {
        description: {
            type: String,
            required: false,
            default: ''
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: true
        }
    }
})
